import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Globe } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              {/* Official G5 Petroleum Logo */}
              <img 
                src="/images/g5_petroleum_logo_1.jpeg" 
                alt="G5 Petroleum Logo" 
                className="h-8 w-8 object-contain"
              />
              <div>
                <div className="font-bold text-lg">G5 Petroleum</div>
                <div className="text-sm text-gray-400">Sdn Bhd</div>
                <div className="text-xs text-gray-500">PETRONAS Reg: 202201037944</div>
              </div>
            </div>
            <p className="text-gray-400 mb-4">
              Engineering solutions for marine, energy & industrial operations across Southeast Asia.
            </p>
            <div className="flex space-x-4">
              <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center">
                <Globe className="h-4 w-4" />
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-400 hover:text-white transition-colors">Home</Link></li>
              <li><Link to="/about" className="text-gray-400 hover:text-white transition-colors">About Us</Link></li>
              <li><Link to="/products" className="text-gray-400 hover:text-white transition-colors">Products & Services</Link></li>
              <li><Link to="/projects" className="text-gray-400 hover:text-white transition-colors">Projects</Link></li>
              <li><Link to="/contact" className="text-gray-400 hover:text-white transition-colors">Contact</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Our Services</h3>
            <ul className="space-y-2 text-gray-400">
              <li>Floating Marine Hose Systems</li>
              <li>Flexible Industrial Hose</li>
              <li>Pig Launcher & Receiver Systems</li>
              <li>Valve Products</li>
              <li>Process Skid Packages</li>
              <li>Ship Brokering & Marine Agent</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Contact Info</h3>
            <div className="space-y-3">
              <a href="tel:+60327790507" className="flex items-center space-x-3 hover:text-blue-300 transition-colors">
                <Phone className="h-4 w-4 text-blue-400" />
                <span className="text-gray-400">Office: +603 2779 0507</span>
              </a>
              <a href="https://wa.me/60192177871" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-3 hover:text-green-300 transition-colors">
                <Phone className="h-4 w-4 text-blue-400" />
                <span className="text-gray-400">WhatsApp: +60 19 2177871</span>
              </a>
              <a href="mailto:sales@g5petro.com.my" className="flex items-center space-x-3 hover:text-blue-300 transition-colors">
                <Mail className="h-4 w-4 text-blue-400" />
                <span className="text-gray-400">sales@g5petro.com.my</span>
              </a>
              <div className="flex items-start space-x-3">
                <MapPin className="h-4 w-4 text-blue-400 mt-1" />
                <div className="text-gray-400">
                  <div>Ampang Jaya, Selangor</div>
                  <div>Malaysia</div>
                  <div className="text-sm">Serving Southeast Asia</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <div className="text-gray-400 text-sm">
            © 2024 G5 Petroleum Sdn Bhd. All rights reserved.
          </div>
          <div className="text-gray-400 text-sm mt-4 md:mt-0">
            Engineering Solutions | Marine & Industrial Operations
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;